var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('Banner'),_c('Feature'),_c('hr'),_c('About'),_c('Intro'),_c('Features'),_c('Screen'),_c('Benefit'),_c('hr'),_c('Team'),_c('Counter'),_c('Faq'),_c('Pathner'),_c('Newsletter'),_c('Contact'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }